import React from 'react';
import "../../../styles/about/main.css";

const Main = () => {
    return (
        <div className="about-main">
            <div className="container main-box">
                <div className="box">
                    <h1 className="my-heading">about us</h1>
                    <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button
                                className="normal-button"
                                id="pills-history-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-history"
                                type="button"
                                role="tab"
                                aria-controls="pills-history"
                                aria-selected="true"
                            >
                                History
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className="normal-button"
                                id="pills-vision-mision-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-vision-mision"
                                type="button"
                                role="tab"
                                aria-controls="pills-vision-mision"
                                aria-selected="false"
                            >
                                Vision &amp; Mision
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className="normal-button active"
                                id="pills-founder-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-founder"
                                type="button"
                                role="tab"
                                aria-controls="pills-founder"
                                aria-selected="false"
                            >
                                Founder
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className="normal-button"
                                id="pills-chancellor-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-chancellor"
                                type="button"
                                role="tab"
                                aria-controls="pills-chancellor"
                                aria-selected="false"
                            >
                                H.E. Chancellor
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className="normal-button"
                                id="pills-vice-chancellorunder-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-vice-chancellorunder"
                                type="button"
                                role="tab"
                                aria-controls="pills-vice-chancellorunder"
                                aria-selected="false"
                            >
                                Vice Chancellor
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className="normal-button"
                                id="pills-governance-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-governance"
                                type="button"
                                role="tab"
                                aria-controls="pills-governance"
                                aria-selected="false"
                            >
                                Governance
                            </button>
                        </li>
                    </ul>
                    <div className="tab-content" id="pills-tabContent">
                        <div
                            className="tab-pane fade"
                            id="pills-history"
                            role="tabpanel"
                            aria-labelledby="pills-history-tab"
                        >
                            <div className="details" id="founder">
                                <h1>University History</h1>
                                <div className="sec-box mt-3">
                                    <div className="col-lg-5 col-sm-12 image">
                                        <div
                                            id="carouselExampleIndicators"
                                            className="carousel slide"
                                            data-bs-ride="carousel"
                                        >
                                            <div className="carousel-indicators">
                                                <button
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide-to={0}
                                                    className="active"
                                                    aria-current="true"
                                                    aria-label="Slide 1"
                                                />
                                                <button
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide-to={1}
                                                    aria-label="Slide 2"
                                                />
                                                <button
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide-to={2}
                                                    aria-label="Slide 3"
                                                />
                                                <button
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide-to={3}
                                                    aria-label="Slide 4"
                                                />
                                                <button
                                                    type="button"
                                                    data-bs-target="#carouselExampleIndicators"
                                                    data-bs-slide-to={4}
                                                    aria-label="Slide 5"
                                                />
                                            </div>
                                            <div className="carousel-inner">
                                                <div className="carousel-item active">
                                                    <img
                                                        src="../assets/images/about/bg2.jpg"
                                                        className="d-block w-100"
                                                        alt="..."
                                                    />
                                                </div>
                                                <div className="carousel-item">
                                                    <img
                                                        src="../assets/images/about/bg3.jpg"
                                                        className="d-block w-100"
                                                        alt="..."
                                                    />
                                                </div>
                                                <div className="carousel-item">
                                                    <img
                                                        src="../assets/images/about/bg4.jpg"
                                                        className="d-block w-100"
                                                        alt="..."
                                                    />
                                                </div>
                                                <div className="carousel-item">
                                                    <img
                                                        src="../assets/images/about/bg-5.jpg"
                                                        className="d-block w-100"
                                                        alt="..."
                                                    />
                                                </div>
                                            </div>
                                            <button
                                                className="carousel-control-prev"
                                                type="button"
                                                data-bs-target="#carouselExampleIndicators"
                                                data-bs-slide="prev"
                                            >
                                                <span
                                                    className="carousel-control-prev-icon"
                                                    aria-hidden="true"
                                                />
                                                <span className="visually-hidden">Previous</span>
                                            </button>
                                            <button
                                                className="carousel-control-next"
                                                type="button"
                                                data-bs-target="#carouselExampleIndicators"
                                                data-bs-slide="next"
                                            >
                                                <span
                                                    className="carousel-control-next-icon"
                                                    aria-hidden="true"
                                                />
                                                <span className="visually-hidden">Next</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-lg-7 col-sm-12 content">
                                        <p>
                                            Chaudhary Charan Singh University (formerly, Meerut
                                            University) was established in 1965, to cater to the needs of
                                            higher education in western Uttar Pradesh. The University
                                            celebrated its silver jubilee in 1991. Presently, it is one of
                                            the premier educational institutions of the country
                                            encompassing a vast, beautiful, and pollution-free campus that
                                            sprawls over 222 acres of land having vast playgrounds and
                                            experimental fields, a botanical garden, a rose garden with a
                                            life-size statue of the late Prime Minister Ch. Charan Singh,
                                            Gymnasium, Indoor Stadium, well equipped Library, Hostels for
                                            both girls and boys, Administrative Block, Spacious
                                            Auditorium, Guest House, Community Centre, Medical Centre,
                                            Residential Quarters for faculty members and employees,
                                            Canteen, Bank, and Post office. The teaching department
                                            belonging to different faculties, is housed in spacious
                                            buildings and has well-equipped laboratories and advanced
                                            facilities. The University also has a separate engineering
                                            college, which is currently offering courses leading to
                                            B.Tech. degree in several different branches of engineering.
                                        </p>
                                        <p>
                                            Initially, the M.Phil. and Ph.D. programmes were started in
                                            1969 taking credit for becoming the first University in the
                                            country to introduce M.Phil. programme.
                                        </p>
                                    </div>
                                </div>
                                <div className="sec-box mt-3">
                                    <div className="col-lg-12 col-sm-12 content pl0">
                                        <p>
                                            In 1973, Post Graduate level courses were also introduced with
                                            the modernized syllabi. Since then, the University has been
                                            progressing at a steady rate. During the VIII five-year plan,
                                            the introduction of self-financed courses keeping in pace with
                                            the changing demands of the society and also for human
                                            resources development, were planned. Now, there are five
                                            faculties with 22 UGC sponsored and 35
                                            self-financed/job-oriented courses being run on the campus.
                                            252 professional colleges/institutions 109 colleges and one
                                            constituent college are affiliated with Chaudhary Charan Singh
                                            University.
                                        </p>
                                        <p>
                                            Under the able leadership of the Vice Chancellor, a renowned
                                            innovative technologist and an established committed academic
                                            administrator, the university is offering a large number of
                                            new and innovative post-graduate, under- graduate, diploma,
                                            advanced diploma, and postgraduate diploma courses under the
                                            self-financed scheme in areas of Agricultural Sciences,
                                            Humanities, Social Sciences, Journalism, Mass Communication
                                            and Multimedia Techniques, Earth Sciences, Teacher and
                                            Physical Education, Fine Arts, Legal Studies, Applied
                                            Sciences, Home Science, Business Studies, Geographical
                                            Information System (GIS) and Remote Censoring.
                                        </p>
                                        <p>
                                            A distinct feature of the academic program is the semester
                                            system and the continuous evolution of the students through
                                            quizzes, tests, and seminars. The academic program exposes the
                                            students to practical aspects through computer labs, seminars,
                                            group discussions, and lectures of experts invited from other
                                            institutions. The recognition of the university is due to the
                                            efforts of well-qualified and committed faculty members who
                                            have been providing quality education to postgraduate, M.Phil.
                                            and Ph.D. students. The University has also made a mark in the
                                            field of sports, and our students are second to none in their
                                            achievements.
                                        </p>
                                        <p>
                                            The University has always been proud of its alumni who occupy
                                            high positions of great responsibility and distinction in
                                            educational and research institutions in India and abroad and
                                            administrative positions in the industries, defence, and civil
                                            services. The success of the students of the university in
                                            NET, GATE, ARS, GRE, and other examinations such as civil and
                                            administrative services, etc. speak of the standard and
                                            quality of education provided by the university. The research
                                            activities in the university's various departments are
                                            supported by grants in the form of research projects
                                            sanctioned by UGC, DBT, DST, ICAR, AICTE, UPSTC, CSIR, and
                                            other funding agencies of the central and state governments.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="tab-pane fade"
                            id="pills-vision-mision"
                            role="tabpanel"
                            aria-labelledby="pills-vision-mision-tab"
                        >
                            <div className="details" id="our-vision">
                                <h1>Vision &amp; Mission</h1>
                                <div className="sec-box mt-3 vm">
                                    <div className="col-lg-6 col-sm-12 image">
                                        <h3 className="text-center">
                                            <em>मन: सृष्टि</em>
                                        </h3>
                                        <img src="../assets/images/about/manshrshti.jpg" alt="" />
                                    </div>
                                    <div className="col-lg-6 col-sm-12 content">
                                        <h2>Our Vision</h2>
                                        <p>
                                            "To produce such professionals who have global competence,
                                            vision, and skills as are necessary to meet the challenges of
                                            emerging global knowledge economy, by the power of innovation,
                                            creativity and efficient learning ability."
                                        </p>
                                    </div>
                                </div>
                                <div className="sec-box mt-3 om">
                                    <div className="col-lg-6 col-sm-12 content pl0 pr15">
                                        <h2>Our Mission</h2>
                                        <p>
                                            "To provide access to quality education and excellence through
                                            rigorous efforts of critical thinking, collaborative research,
                                            and knowledge creation of global standards in a cooperative
                                            ambiance founded on Indian wisdom and values, transforming
                                            India into a developed nation".
                                        </p>
                                    </div>
                                    <div className="col-lg-6 col-sm-12 image">
                                        <h3 className="text-center">
                                            <em>संकल्प</em>
                                        </h3>
                                        <img src="../assets/images/about/mission-n.jpg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="tab-pane fade show active"
                            id="pills-founder"
                            role="tabpanel"
                            aria-labelledby="pills-founder-tab"
                        >
                            <div className="details" id="founder">
                                <h1>Hon'ble Chaudhary Charan Singh Ji</h1>
                                <p>Founder &amp; Former Prime Minister</p>
                                <div className="sec-box mt-3">
                                    <div className="col-lg-4 col-sm-12 image">
                                        <img src="../assets/images/about/owner1.jpg" alt="" />
                                    </div>
                                    <div className="col-lg-8 col-sm-12 content">
                                        <p>
                                            Chaudhary Charan Singh was born on December 23, 1902 in
                                            village Noorpur, town Hapur, District Ghaziabad of Uttar
                                            Pradesh in a poor peasant's family. He was a good student, and
                                            received a Master of Art degree in 1925 and Law degree in 1926
                                            from Meerut College .In February 1937 he was elected to the
                                            Legislative Assembly of Uttar Pradesh (United Provinces)
                                            Chhaprouli (Baghpat) at the age of 34. In 1938 he introduced
                                            an Agricultural Produce Market Bill in the Assembly which was
                                            intended to safeguard the interests of the farmers against the
                                            rapacity of the traders. The Bill was adopted by most of the
                                            States in India. He was influenced by Mahatma Gandhi’s
                                            non-violence and entered India’s Independence Movement. After
                                            India’s independence he came to be associated with socialism
                                            in the rural areas.In 1952 he was Revenue Minister of Uttar
                                            Pradesh and one of his major contributions was that he did
                                            away with the Zamindari system and also brought in Land Reform
                                            Acts. He was a strong opponent of Nehru's socialism and fell
                                            out with the Congress party. He left Congress in 1967 and
                                            formed his independent party known as the Bharatiya Lok Dal.
                                            He served twice as Chief Minister of Uttar Pradesh.
                                        </p>
                                        <p>
                                            He became Prime Minister of India in 1979. His speech to the
                                            nation on India's Independence Day (15 August 1979) was very
                                            prophetic in which he identified Pakistan's nuclear ambition
                                            as a major threat to India. He also mentioned that Indian
                                            labour laws had to be refined if India were to become
                                            competitive in world economy. He also opened high level
                                            diplomatic relations with Israel, which later Indira Gandhi's
                                            government curtailed.
                                        </p>
                                    </div>
                                </div>
                                <div className="sec-box mt-4">
                                    <div className="col-lg-4 col-sm-12 image">
                                        <img src="../assets/images/about/about-book.svg" alt="" />
                                    </div>
                                    <div className="col-lg-8 col-sm-12 content">
                                        <h1>He has written several books. Some of them are:</h1>
                                        <ul>
                                            <li>India's Economic Policy - The Gandhian Blueprint</li>
                                            <li>Economic Nightmare of India - Its Cause and Cure</li>
                                            <li>Cooperative Farming X-rayed</li>
                                        </ul>
                                        <p>
                                            Chaudhary Charan Singh passed away on 29 May 1987. His
                                            memorial in New Delhi was named as Kisan Ghat because of his
                                            lifelong association with the farming communities of Northern
                                            India.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="tab-pane fade"
                            id="pills-chancellor"
                            role="tabpanel"
                            aria-labelledby="pills-chancellor-tab"
                        >
                            <div className="details" id="chancellor">
                                <h1>Hon'ble Smt. Anandiben Patel</h1>
                                <p>Governor of Uttar Pradesh</p>
                                <div className="sec-box mt-3">
                                    <div className="col-lg-4 col-sm-12 image">
                                        <img src="../assets/images/about/anandiben-patel.jpg" alt="" />
                                    </div>
                                    <div className="col-lg-8 col-sm-12 content">
                                        <p>
                                            <strong>Brief Introduction</strong>
                                            <br />
                                            Anandiben Patel is an Indian politician and the current
                                            Governor of Uttar Pradesh and former Chief Minister of
                                            Gujarat, a western state of India. She was the first woman
                                            chief minister of the state. She is a member of the Bharatiya
                                            Janata Party since 1987. She was the Cabinet Minister for
                                            Education from 2002 to 2007.
                                        </p>
                                        <table width="100%" className="">
                                            <tbody>
                                                <tr>
                                                    <th colSpan={2}>Life Introduction</th>
                                                </tr>
                                                <tr>
                                                    <td width="25%">Name</td>
                                                    <td width="75%">Smt. Anandiben Mafatbhai Patel</td>
                                                </tr>
                                                <tr>
                                                    <td>Date of Birth</td>
                                                    <td>November 21, 1941</td>
                                                </tr>
                                                <tr>
                                                    <td valign="top">Birth Place</td>
                                                    <td>Kharod, Bijapur Taluka, District Mahesana.</td>
                                                </tr>
                                                <tr>
                                                    <td>Permanent Address</td>
                                                    <td>''Dharam', near Shan Bungalows, Shilaj Ahmedabad.</td>
                                                </tr>
                                                <tr>
                                                    <td>Current Address</td>
                                                    <td>Raj Bhavan, Uttar Pradesh Lucknow</td>
                                                </tr>
                                                <tr>
                                                    <td>Education</td>
                                                    <td>MSc, M.Ed (Gold Medalist).</td>
                                                </tr>
                                                <tr>
                                                    <td valign="top">Occupation</td>
                                                    <td>
                                                        Retired Principal (Mohinaba Girls High School,
                                                        Ahmedabad) and Social Services
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top">Literary Activities</td>
                                                    <td>
                                                        Writing articles for 'Earth', 'Sadhana' and 'Sakhi'
                                                        magazines from time to time.
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td valign="top">Interests</td>
                                                    <td>Study, Writing, Travel, Public Relations.</td>
                                                </tr>
                                                <tr>
                                                    <td valign="top">Published Books</td>
                                                    <td>
                                                        <p>
                                                            - 'A mane hamesha yaad raheshe' (Gujarati
                                                            Edition).&nbsp;
                                                            <br />
                                                            - ‘Prayas’&nbsp;
                                                            <br />- ‘Pratibimb’
                                                        </p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={2}>
                                                        <a
                                                            href="https://upgovernor.gov.in/en/page/profile"
                                                            target="_blank"
                                                            rel='noreferrer'
                                                            className="stylered"
                                                        >
                                                            <strong>Read More</strong>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="tab-pane fade"
                            id="pills-vice-chancellorunder"
                            role="tabpanel"
                            aria-labelledby="pills-vice-chancellorunder-tab"
                        >
                            <div className="details" id="vice-chancellorunder">
                                <h1>Prof. Sangeeta Shukla</h1>
                                <p>Vice Chancellor</p>
                                <div className="sec-box mt-3">
                                    <div className="col-lg-4 col-sm-12 image">
                                        <img src="../assets/images/about/sangeeta-shukla.jpg" alt="" />
                                    </div>
                                    <div className="col-lg-8 col-sm-12 content">
                                        <p>
                                            India, the oldest civilisation and the oldest nation of the
                                            world, inherits a rich tradition of intellectual exploration.
                                            The Rigveda prayer :' आ नो भद्रा क्रतवो यन्तु विश्वतः' (Let
                                            the noble ideas come to us from the entire world.) underlines
                                            the openness in Indian thinking since ancient times. Even in
                                            the ancient period, India led the higher education system of
                                            the world, attracting student population from a number of
                                            countries to its famous seats of learning at Takshila and
                                            Nalanda.
                                        </p>
                                        <p>
                                            Established in 1965, the Chaudhary Charan Singh University,
                                            Meerut (formerly known as Meerut University, Meerut) has been
                                            continuously engaged in creation and dissemination of world
                                            class knowledge by involving all the stake-holders, i.e.,
                                            students, teachers, supporting staff and the people from
                                            different walks of the society. Over the years, it has
                                            steadily evolved itself as one of the leading centers of
                                            comprehensive learning with its exposure to and linkages with
                                            the peers at national and international levels. With its state
                                            of the art infrastructure, well equipped laboratories and
                                            highly qualified and dedicated faculty, the University is
                                            committed to the task of harnessing and cultivating the
                                            capabilities of young students with a view to enabling them to
                                            carve suitable space for themselves in the modern economic
                                            world.
                                        </p>
                                    </div>
                                </div>
                                <div className="sec-box mt-3">
                                    <div className="col-lg-12 col-sm-12 content pl0">
                                        <p>
                                            Conscious of its social responsibility and accountability, the
                                            University since its inception has been striving hard to
                                            inculcate the right values among students so as to develop
                                            them as socially sensitive citizens.
                                        </p>
                                        <p>
                                            Sustainable development and inclusiveness being our main
                                            mottos, the university encourages teaching and research
                                            programmes addressing the issues of concern to the
                                            contemporary society. Thus, the system encourages not only the
                                            curricular activities, but also promotes co-currical,
                                            extracurricular and extension activities through its outreach
                                            to and interaction with the local community.
                                        </p>
                                        <p>
                                            While we have come a long way and our academic journey is
                                            marked by a number of path breaking milestones, we have to
                                            keep pace with the fast changing needs and expectations of the
                                            society. The process of creating new knowledge and producing
                                            capable human beings dedicated to the upliftment of the nation
                                            and the world has to continue with renewed vigour in an
                                            unabated manner.
                                        </p>
                                        <p>
                                            I extend my best wishes to all the students, teachers and
                                            members of the administrative staff who are part of the
                                            University and to those also who intend to join us in our
                                            endeavour to liberate the humanity with the help of the
                                            powerful tool of knowledge.
                                        </p>
                                        <p>
                                            <em>
                                                <strong>Prof.</strong> Sangeeta Shukla
                                            </em>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="tab-pane fade"
                            id="pills-governance"
                            role="tabpanel"
                            aria-labelledby="pills-governance-tab"
                        >
                            <div className="details" id="governance">
                                <h1>Governance</h1>
                                <div className="sec-box mt-3">
                                    <div className="col-lg-12 col-sm-12 content">
                                        <table width="100%" className="">
                                            <tbody>
                                                <tr>
                                                    <th colSpan={2}>University Statutes</th>
                                                </tr>
                                                <tr>
                                                    <td width="25%">Vol-1</td>
                                                    <td width="75%">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/vol-1.pdf"
                                                            target="_blank"
                                                            rel='noreferrer'
                                                            className="stylered"
                                                        >
                                                            <strong>Click to View</strong>
                                                        </a>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Vol-2</td>
                                                    <td>
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/vol-2.pdf"
                                                            target="_blank"
                                                            rel='noreferrer'
                                                            className="stylered"
                                                        >
                                                            <strong>Click to View</strong>
                                                        </a>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th colSpan={2}>University Ordinances</th>
                                                </tr>
                                                <tr>
                                                    <td width="25%">2014</td>
                                                    <td width="75%">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/ord-2014.pdf"
                                                            target="_blank"
                                                            rel='noreferrer'
                                                            className="stylered"
                                                        >
                                                            <strong>Click to View</strong>
                                                        </a>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>2013</td>
                                                    <td>
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/ord-2013.pdf"
                                                            target="_blank"
                                                            rel='noreferrer'
                                                            className="stylered"
                                                        >
                                                            <strong>Click to View</strong>
                                                        </a>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th colSpan={2}>
                                                        Students Handbook on Code of Ethics and Conduct
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td width="25%">Students Handbook</td>
                                                    <td width="75%">
                                                        <a
                                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsu/All-PDF/Students-Handbook.pdf"
                                                            target="_blank"
                                                            rel='noreferrer'
                                                            className="stylered"
                                                        >
                                                            <strong>Click to View</strong>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Main;